import React from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  XIcon,
  TwitterShareButton, ViberIcon, ViberShareButton, WhatsappIcon, WhatsappShareButton
} from 'react-share';

const SocialMedia = () => (
  <div className="share-container">
    <div className="title">
      Like us? Share us!
    </div>
    <ShareButtons />
  </div>
);

export const ShareButtons = ({ url = 'http://www.wasp-project.net/', title }) => (
  <div className="social-media-container">
    <FacebookShareButton url={url}>
      <FacebookIcon round size={32} />
    </FacebookShareButton>
    <TwitterShareButton url={url} title={title}>
      <XIcon round size={32} />
    </TwitterShareButton>
    <LinkedinShareButton url={url} title={title}>
      <LinkedinIcon round size={32} />
    </LinkedinShareButton>
    <WhatsappShareButton url={url} title={title}>
      <WhatsappIcon round size={32} />
    </WhatsappShareButton>
    <ViberShareButton url={url} title={title}>
      <ViberIcon round size={32} />
    </ViberShareButton>
  </div>
)

export default SocialMedia;
